export const locale = {
  lang: 'en',
  data: {
    NAV: {
      ADMIN: 'Admin space',
      CATALOG: 'Catalog',
      CUSTOMER: 'Customer',
      CUSTOMER_AREA: 'Customer area',
      CUSTOMERAREA: {
        PRODUCTION: 'Documents',
        RATE: 'Rate',
      },
      DIRECTORY: 'Directory',
      HOME: {
        TITLE: 'Home',
      },
      INVOICE: 'Invoices',
      ITEM: 'Items',
      JOURNAL: 'Journals',
      LABORATORY: 'Laboratories',
      LABORATORY_AREA: 'Prothesist area',
      MANUFACTURER: 'Manufacturers',
      MATERIAL: 'Raw Materials',
      PATIENT: 'Patients',
      PAYMENT: 'Payments',
      PRODUCTION: 'Production Flows',
      PURCHASE_INVOICE: 'Purchase invoices',
      RATE: 'Rates',
      RESOURCE: 'Resources',
      SPONSORSHIP: 'Sponsorship offer',
      SHADE: 'Shades',
      USER: 'User accounts',
    },
  },
};
